import ButtonText from '../Text'

function Icon({ Icon, beforeIconProps, isSkeleton, ...restProps }) {
  return (
    <ButtonText
      {...restProps}
      beforeIconProps={{
        ...beforeIconProps,
        Icon,
      }}
      isSkeleton={isSkeleton}
    />
  )
}

export default Icon
